<div class="modal-dialog">
    <img src="../../../assets/images/scanned_item_added_ok.png" class="img-fluid" />
</div>
